

function setActiveTab(contentTabs, activeId = 0){
    let contentTabsHeader = contentTabs.querySelector('.tabs__header');
    let contentTabsContent = contentTabs.querySelector('.tabs__bodys');

    if(contentTabsHeader && contentTabsContent){
        let contents = contentTabsContent.children;
        let contentHeaderChildren = contentTabsHeader.children;

        if(contents){
            let count = 0;
            for(let contentHeaderTab of contentHeaderChildren){
                contentHeaderTab.classList.remove("is-active");
                if(count === activeId){
                    contentHeaderTab.classList.add("is-active");
                }
                count++;
            }
            count = 0;
            for(let content of contents){
                content.classList.remove("is-active");
                if(count === activeId){
                    content.classList.add("is-active");
                }
                count++;
            }
        }
    }
}

function buildTabs(contentTabs){
    let contentTabsHeader = contentTabs.querySelector('.tabs__header');
    let contentTabsContent = contentTabs.querySelector('.tabs__bodys');

    if(contentTabsHeader && contentTabsContent){
        let contents = contentTabsContent.children;

        if(contents){
            for(let content of contents){
                content.classList.add("tabs__body");
            }
        }
    }

    contentTabs.classList.add("initialized");
}

function getCurrentIndex(tabs,currentTab){
    let index = 0;

    for(let tab of tabs){
        if(tab === currentTab){
            return index;
        }
        index++;
    }
}

function setEventListenerForTab(contentTabs){
    let contentTabsHeader = contentTabs.querySelector('.tabs__header');
    if(contentTabsHeader){
        let contentHeaderChildren = contentTabsHeader.children;

        if(contentHeaderChildren){
            for(let tab of contentHeaderChildren){
                tab.addEventListener("click",function (){
                    setActiveTab(contentTabs,getCurrentIndex(contentHeaderChildren,tab));
                });
            }
        }
    }
}

export function initTabs(wrapper = document){
    for(let tabs of wrapper.querySelectorAll('.tabs')){
        buildTabs(tabs);
        setActiveTab(tabs);
        setEventListenerForTab(tabs);
    }
}